/** @format */

// set of utility helpers and one-liners to make code more readable

// Assign method copies all enumerable own properties from one or more
// source objects to a new object.
export const assign = (...args) => Object.assign({}, ...args);
